import React, { useEffect } from 'react';
import { useIntersectionObserver } from 'usehooks-ts';
import { ScrollComponentProps } from './Types';
import * as S from './Styles';

export const ScrollComponent = ({ children, fireOnInView, observerRef, index }: ScrollComponentProps) => {
  const dataRef = useIntersectionObserver(observerRef, {});

  useEffect(() => {
    if (dataRef?.isIntersecting) {
      fireOnInView();
    }
  }, [dataRef, fireOnInView]);

  return (
    <S.Section $isTopElement={index === 0} ref={observerRef}>
      <S.SectionContent>{children}</S.SectionContent>
    </S.Section>
  );
};
